module.exports = __webpack_public_path__ + "images/local-pro-mobile-mock-800w.jp2";